import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.boundDisable = this.disable.bind(this)
    this.element.addEventListener('click', this.boundDisable)
  }

  disconnect() {
    this.element.removeEventListener('click', this.boundDisable)
  }

  disable() {
    if (this.element.dataset.disableOnClickDisabled === '1') return
    this.element.dataset.disableOnClickDisabled = '1'

    if (this.element.tagName === 'BUTTON' || this.element.tagName === 'INPUT') {
      this.element.disabled = true
    } else {
      this.element.style.pointerEvents = 'none'
      this.element.setAttribute('aria-disabled', 'true')
    }
    this.element.classList.add('disabled')
    this.prependSpinner()
  }

  prependSpinner() {
    const spinner = document.createElement('span')
    spinner.className = 'spinner-border spinner-border-sm me-2'
    spinner.setAttribute('role', 'status')
    spinner.setAttribute('aria-hidden', 'true')
    this.element.prepend(spinner)
  }
}
